<template>
  <BaseLink
    v-bind="$attrs"
    class="action-button"
    @click="$emit('click', $event)">
    <span class="text-button">
      {{ text }}
    </span>
    <SvgChevronRight/>
  </BaseLink>
</template>

<script setup>
import BaseLink from '@shared/components/BaseLink.vue'
import SvgChevronRight from '@/components/global/svg/SvgChevronRight.vue'

defineProps({
  text: {
    type: String,
    default: ''
  }
})

defineEmits(['click'])
</script>

<style lang="scss" scoped>
.action-button {
	color: $armor;
	width: 100%;
  display: flex;
	justify-content: space-between;
  padding: $spacing-xxs 0;
    	&:hover {
		color: $plum;
      }
    &[disabled] {
      	color: $ash;
    }
}
</style>
